import { Action } from '@ngrx/store';
import { ValueAddedOP, TechnicalProductsResponseOP } from '@cemex-core/cmx-api';

export enum ActionTypes {
  SELECT = '[RMS OLC UL Added Values] Select',
  ADD_MANDATORIES = '[RMS OLC UL Added Values] Add Mandatories',
  FETCH = '[RMS OLC UL Added Values] Fetch',
  FETCH_FAILURE = '[RMS OLC UL Added Values] Fetch Failure',
  FETCH_FIRST_GROUP_SUCCESS = '[RMS OLC UL Added Values] Fetch First Group Success',
  FETCH_SECOND_GROUP_SUCCESS = '[RMS OLC UL Added Values] Fetch Second Group Success',
  FETCH_THIRD_GROUP_SUCCESS = '[RMS OLC UL Added Values] Fetch Third Group Success',
  FETCH_FOURTH_GROUP_SUCCESS = '[RMS OLC UL Added Values] Fetch Fourth Group Success',
  RESET = '[RMS OLC UL Added Values] Reset',
}

export class Select implements Action {
  readonly type: string = ActionTypes.SELECT;
  constructor(public payload: { group: number; code: string }) {}
}

export class AddMandatories implements Action {
  readonly type: string = ActionTypes.ADD_MANDATORIES;
  constructor(public payload: ValueAddedOP[]) {}
}

export class Fetch implements Action {
  readonly type: string = ActionTypes.FETCH;
  constructor(public payload: number) {}
}

export class FetchFirstGroupSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_FIRST_GROUP_SUCCESS;
  constructor(public payload: TechnicalProductsResponseOP) {}
}

export class FetchSecondGroupSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_SECOND_GROUP_SUCCESS;
  constructor(public payload: TechnicalProductsResponseOP) {}
}

export class FetchThirdGroupSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_THIRD_GROUP_SUCCESS;
  constructor(public payload: TechnicalProductsResponseOP) {}
}

export class FetchFourthGroupSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_FOURTH_GROUP_SUCCESS;
  constructor(public payload: TechnicalProductsResponseOP) {}
}

export class FetchFailure implements Action {
  readonly type: string = ActionTypes.FETCH_FAILURE;
  constructor(public payload?: any) {}
}

export class Reset implements Action {
  readonly type = ActionTypes.RESET;
  constructor(public payload?: any) {}
}

export type Actions =
  | Fetch
  | FetchFirstGroupSuccess
  | FetchSecondGroupSuccess
  | FetchThirdGroupSuccess
  | FetchFourthGroupSuccess
  | FetchFailure
  | AddMandatories
  | Select
  | Reset;
